import type { FC } from "react";
import { useSearchParams } from "react-router-dom";
import { BannerPageEnum } from "types/cms";

import { PageLayout } from "src/components";
import { PAGE_PARAM } from "src/routes";
import { getUser, useOrdersByUserIdQuery } from "src/serverApi";
import { useTranslation } from "src/translations";
import { useAppSelector } from "src/utils";
import { OrdersTable } from "./components";

export const OrdersPage: FC = () => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const page = Number(searchParams.get(PAGE_PARAM)) || 1;

    const user = useAppSelector(getUser);
    const { data: orders, isLoading } = useOrdersByUserIdQuery({ userId: user.id!, page });

    return (
        <PageLayout title={t("orders.title")} loading={isLoading} banner={BannerPageEnum.Orders}>
            {orders && <OrdersTable orders={orders} />}
        </PageLayout>
    );
};
